import React from 'react';
import PropTypes from 'prop-types';
import Message from 'Components/Modal/Message';

const CouponPlayWaiting = props => {
  const buttonConfig = {
    primary: {
      label: 'KUPONLARIMA GİT',
      onClick: props.onPrimaryButtonClick
    }
  };

  const defaultMessage = 'Yanıt süreci <b>Spor Toto Ana Bayisi Şans Girişim</b> üzerinden ilerler. <b>Bu durum Bilyoner kaynaklı değildir.2</b> Onaylanmayan kuponların tutarları iade edilir.';

  return (
    <Message type="none" buttonConfig={ buttonConfig } hasIcon={ true }>
      <p dangerouslySetInnerHTML={ { __html: props.message || defaultMessage } }/>
    </Message>
  );
};

CouponPlayWaiting.propTypes = {
  onPrimaryButtonClick: PropTypes.func.isRequired,
  message: PropTypes.string
};

export default CouponPlayWaiting;
